import { FC } from 'react'
import {
  DatePicker as AntdDatePicker,
  type DatePickerProps as AntdDatePickerProps,
} from 'antd'
import cn from 'classnames'
import classes from './index.module.css'

type DatePickerProps = AntdDatePickerProps & {
  size?: 'middle' | 'small'
}

const DatePicker: FC<DatePickerProps> = ({ className, size, ...props }) => {
  return (
    <AntdDatePicker
      {...props}
      className={cn(className, classes.dataPicker, {
        [classes.dataPickerSmall]: size === 'small',
      })}
    />
  )
}

export default DatePicker
